export default "__VITE_PUBLIC_ASSET__10758007__"